import _slicedToArray from "/root/workspace/__flow_work/__flow_builds/4b0429b5-cad2-45c8-80ed-a3346422ad2c/workspace/life-h5_pcAM/node_modules/_@babel_runtime@7.29.7@@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.string.repeat.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.trim.js";
export var evals = function evals(str) {
  return "55555";
};
export var minus = function minus(value) {
  if (value) {
    if (value > 0) {
      return "+" + value;
    } else {
      return value;
    }
  }
};
export var KeyWord = function KeyWord(keys, e) {
  if (e.indexOf(keys) > 0) {
    return keys;
  } else {
    return "过滤器";
  }
};
export var calculate = function calculate(value) {
  if (value) {
    if (value <= 0) {
      return 0.0;
    } else {
      return value.toFixed(2);
    }
  } else {
    return "0.00";
  }
};
export var href_filters = function href_filters(url) {
  if (!url) {
    return "javascript:;";
  }
  var host = document.location.host;
  var mid = decodeURIComponent((new RegExp("[?|&]" + "mid" + "=" + "([^&;]+?)(&|#|;|$)").exec(location.href) || [, ""])[1].replace(/\+/g, "%20")) || null;
  if (url.indexOf(host) >= 0) {
    if (url.indexOf("?") >= 0) {
      return url + "&mid=" + mid;
    } else {
      return url + "?mid=" + mid;
    }
  } else {
    return url;
  }
};
export var mobile_dispose = function mobile_dispose(value) {
  if (value) {
    return value.substr(0, 3) + "****" + value.substr(7, value.length - 1);
  } else {
    return "";
  }
};
export var normalTime = function normalTime(time) {
  if (time) {
    return "时间过滤器" + time;
  }
};
export var pwd_filter = function pwd_filter(value) {
  if (value) {
    return "*";
  } else {
    return "";
  }
};
export var trainMinPirce = function trainMinPirce(pirces) {
  console.log("pirces", pirces);
  if (pirces == null || pirces == "" || pirces == undefined) {
    return "--";
  }
  if (pirces.length > 0) {
    pirces = pirces.sort(function (a, b) {
      return a.seatPrice - b.seatPrice;
    });
    return pirces[0].seatPrice;
  } else {
    return "--";
  }
};
export var trainRunTime = function trainRunTime(time) {
  if (time > 0) {
    var h = parseInt(time / 3600);
    //let m=(time-h*3600);
    var m = parseInt((time - h * 3600) / 60);
    return h + "时" + m + "分";
  } else {
    return "--";
  }
};

//处理问题：转义字符后台转义后通过接口返回又被转义
export var escapeTitle = function escapeTitle(a) {
  if (!a) return "请填写商品标题";
  a = "" + a;
  return a.replace(/&#60;/g, "<").replace(/&#062;/g, ">").replace(/&#038;/g, "&").replace(/&#034;/g, '"').replace(/&#039;/g, "'").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&").replace(/&quot;/g, '"');
};
export var timestampToTime = function timestampToTime(time) {
  if (!time) {
    return "— —";
  }
  var date = new Date(time * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + "-";
  var M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
  var D = date.getDate() + " ";
  var h = date.getHours() + ":";
  var m = date.getMinutes();
  return Y + M + D + h + m;
};
export var numberToWan = function numberToWan(number) {
  if (!number) return "0";
  var result = 0;
  if (number >= 10000) {
    var newNumber = (Number(number * 100) / 1000000).toFixed(0);
    result = newNumber + "W";
  } else {
    result = Number(number).toFixed(0);
  }
  return result;
};

/**
 * 优化版保留小数点过滤器（智能截取方式）
 * @param {number|string} value 输入值
 * @param {number} [decimals=4] 保留的小数位数，默认为4
 * @returns {string} 格式化后的数字
 */
export var formatFourDecimals = function formatFourDecimals(value) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
  // 处理空值和0
  if (value === null || value === undefined || value === "" || value === 0) {
    return "0";
  }
  var str = String(value).trim();
  // 处理科学计数法
  if (/[eE]/.test(str)) {
    var num = Number(str);
    if (isNaN(num)) return "0";
    str = num.toString();
  }

  // 检查是否为有效数字
  if (!/^-?\d*\.?\d*$/.test(str)) {
    return "0";
  }
  var isNegative = str.startsWith("-");
  if (isNegative) {
    str = str.substring(1);
  }
  // 分割整数和小数部分
  var _str$split = str.split("."),
    _str$split2 = _slicedToArray(_str$split, 2),
    _str$split2$ = _str$split2[0],
    integer = _str$split2$ === void 0 ? "0" : _str$split2$,
    _str$split2$2 = _str$split2[1],
    decimal = _str$split2$2 === void 0 ? "" : _str$split2$2;
  // 处理纯整数情况
  if (!decimal) {
    return (isNegative ? "-" : "") + integer;
  }
  // 截取指定位数的有效小数
  var trimmedDecimal = decimal.substring(0, decimals);
  // 去除末尾的0
  while (trimmedDecimal.length > 0 && trimmedDecimal.endsWith("0")) {
    trimmedDecimal = trimmedDecimal.slice(0, -1);
  }
  // 如果没有小数部分，只返回整数
  if (trimmedDecimal.length === 0) {
    return (isNegative ? "-" : "") + integer;
  }
  return (isNegative ? "-" : "") + "".concat(integer, ".").concat(trimmedDecimal);
};

/**
 * 优化版小数点移动过滤器 - 支持自定义移动位数，去除无意义的0
 * @param {number|string} value 输入值
 * @param {string} direction 移动方向: 'right'(乘法) 或 'left'(除法)，默认为'right'
 * @param {number} digits 移动位数，默认为2
 * @returns {string} 转换后的数值字符串
 */
export var moveDecimal = function moveDecimal(value) {
  var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "right";
  var digits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  // 处理空值
  if (value === null || value === undefined || value === "") {
    return "0";
  }
  // 转为字符串并去除空格
  var str = String(value).trim();
  // 检查是否为有效数字
  if (!/^-?\d*\.?\d*$/.test(str)) {
    return "0";
  }
  // 处理正负号
  var isNegative = str.startsWith("-");
  if (isNegative) {
    str = str.substring(1);
  }
  // 分割整数和小数部分
  var _str$split3 = str.split("."),
    _str$split4 = _slicedToArray(_str$split3, 2),
    _str$split4$ = _str$split4[0],
    integer = _str$split4$ === void 0 ? "0" : _str$split4$,
    _str$split4$2 = _str$split4[1],
    decimal = _str$split4$2 === void 0 ? "" : _str$split4$2;
  // 确保整数部分至少为"0"
  if (integer === "") integer = "0";
  var result;
  // 根据方向移动小数点
  if (direction === "right") {
    // 向右移动小数点（乘以10^digits）
    if (decimal.length === 0) {
      // 纯整数，添加digits个0
      result = integer + "0".repeat(digits);
    } else if (decimal.length <= digits) {
      // 小数位数不足digits位，移动后补0
      result = integer + decimal + "0".repeat(digits - decimal.length);
    } else {
      // 小数位数超过digits位，需要在中间插入小数点
      result = integer + decimal.substring(0, digits) + (decimal.length > digits ? "." + decimal.substring(digits) : "");
    }
    // 去除整数部分前导0（除非整数部分就是0）
    if (result.includes(".")) {
      var _result$split = result.split("."),
        _result$split2 = _slicedToArray(_result$split, 2),
        intPart = _result$split2[0],
        decPart = _result$split2[1];
      result = (intPart === "0" ? "0" : intPart.replace(/^0+/, "")) + "." + decPart;
    } else {
      result = result.replace(/^0+/, "") || "0";
    }
  } else {
    // 向左移动小数点（除以10^digits）
    if (integer.length <= digits) {
      // 整数部分不足digits位，需要在前面补0
      var paddedInteger = integer.padStart(digits, "0");
      result = "0." + paddedInteger + decimal;
    } else {
      // 整数部分超过digits位
      var newInteger = integer.substring(0, integer.length - digits);
      var newDecimal = integer.substring(integer.length - digits) + decimal;
      result = newInteger + "." + newDecimal;
    }
  }
  // 去除小数部分末尾的0和可能的小数点
  result = result.replace(/\.(\d*[1-9])0*$|\.0*$/, function (match, p1) {
    return p1 ? ".".concat(p1) : "";
  });
  // 添加负号（如果原数为负）
  return (isNegative ? "-" : "") + result;
};